<template>
    <b-modal
        centered
        size="md"
        no-close-on-backdrop
        no-close-on-esc
        hide-footer
        v-model="form.show"
    >
        <template #modal-header="{}">
            <div class="header flex-grow-1 text-center">
                <h2 class="font-weight-bold">เพิ่มพนักงาน</h2>
            </div>
            <span class="close cursor-pointer" @click="closeModalConfirm()">&times;</span>
        </template>
        <ValidationObserver ref="observer">
            <b-form @submit="onSubmit">
                <card shadow type="secondary" class="m--4">
                    <b-row>
                        <b-col cols="12">
                            <ValidationProvider rules="required|email" v-slot="{ errors }">
                                <b-form-group label="อีเมล">
                                    <b-form-input
                                        placeholder="อีเมล"
                                        v-model="form.admin.email"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12">
                            <ValidationProvider :rules="!form.admin.id ? 'required': ''" v-slot="{ errors }">
                                <b-form-group label="รหัสผ่าน">
                                    <b-form-input
                                        placeholder="รหัสผ่าน"
                                        v-model="form.admin.password"
                                        type="password"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12">
                            <hr class="my-3" />
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="ชื่อ">
                                    <b-form-input
                                        placeholder="ชื่อ"
                                        v-model="form.admin.firstName"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="นามสกุล">
                                    <b-form-input
                                        placeholder="นามสกุล"
                                        v-model="form.admin.lastName"
                                        :state="!errors.length ? null : false"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <!-- <b-col cols="12">
                            <b-form-group label="เบอร์โทรศัพท์">
                                <b-form-input
                                    placeholder="08XXXXXXXX"
                                    v-model="form.admin.tel"
                                />
                            </b-form-group>
                        </b-col> -->
                        <b-col cols="12">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <b-form-group label="สิทธิการเข้าถึง">
                                    <b-form-select
                                        v-model="form.admin.role"
                                        :options="roleList"
                                        :state="!errors.length ? null : false"
                                    >
                                    </b-form-select>
                                    <b-form-invalid-feedback>
                                        {{ errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                    </b-row>
                    <template slot="footer">
                        <b-row class="justify-content-between">
                            <b-col cols="4">
                                <b-button
                                    block
                                    @click="closeModalConfirm()"
                                >
                                    ยกเลิก
                                </b-button>
                            </b-col>
                            <b-col cols="8">
                                <b-button 
                                    type="submit" 
                                    variant="primary"
                                    block
                                    :disabled="form.isLoad"
                                >
                                    <i class="fas fa-circle-notch fa-spin" v-if="form.isLoad"></i> 
                                    ยืนยัน
                                </b-button>
                            </b-col>
                        </b-row>
                    </template>
                </card>
            </b-form>
        </ValidationObserver>
    </b-modal>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { modalSuccess, modalError } from '@/util/alert.js'
import adminServices from "@/api/admin.service.js";

export default {
    props: {
        form: {
            type: Object
        }
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            roleList: [
                { value: null, text: "กรุณาเลือกสิทธิการเข้าถึง" },
                { value: 'admin', text: "Admin" },
                { value: 'superadmin', text: "Superadmin" },
            ],
        }
    },  
    methods: {
        async onSubmit(event) {
            event.preventDefault();
            const isValid = await this.$refs.observer.validate();

            if (!isValid) {
                return;
            }
            const { email, password, firstName, lastName, tel, role, id } = this.form.admin
            const payload = {
                ...!id ? {
                    email: email,
                }: {},
                ...password ? {
                    password: password
                }: {},
                firstname: firstName,
                lastname: lastName,
                // phonenumber: tel,
                role: role,
                ...id ? {
                    admin_id: id
                }: {}
            }

            try {
                const response = id
                    ? await adminServices.updateAdmin(payload)
                    : await adminServices.createAdmin(payload);

                modalSuccess(this.$bvModal, id ? 'แก้ไขข้อมูลพนักงานสำเร็จ' : 'เพิ่มพนักงานสำเร็จ')
                await this.$emit('getAdmin')
                this.closeModalConfirm();
        
            } catch (err) {
                modalError(this.$bvModal, 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
            }

        },
        closeModalConfirm(){
            this.$refs.observer.reset();
            this.form.show = false
            this.form.isLoad = false
            this.form.admin = {
                email: null,
                password: null,
                firstName: null,
                lastName: null,
                tel: null,
                role: null
            }
        }
    }
}
</script>
